import {toast} from 'vue-sonner'

/**
 * Typed wrapper over vue-sonner toast() for app-wide notifications.
 */
export function useToast() {
  return {
    success: (message: string) => toast.success(message),
    error: (message: string) => toast.error(message),
    info: (message: string) => toast.info(message),
    warning: (message: string) => toast.warning(message),
  }
}
